import * as z from 'zod';

import { statusFormSchema } from '@/_schemas/status-input';

import { recruitingJobCategoryQuerySchema } from './recruiting-job-category-query-schema';

export const recruitingJobCategoryFormSchema = recruitingJobCategoryQuerySchema
  .omit({ name: true, status: true })
  .extend({
    name: z.string().min(1),
    status: statusFormSchema,
  });

export type RecruitingJobCategoryFormSchema = z.infer<typeof recruitingJobCategoryFormSchema>;
